import CardTemplate from "@appsinti/ui-core/CardTemplate";
import styled from "styled-components";

const GroupFlexContainer = styled(CardTemplate)<{heightString: string;}>`
  &.full-width {
    max-width: 100%;
    width: 100%;
    flex: 0 0 auto;
  }

  &.half-width {
    max-width: 50%;
    flex: 0 0 auto;
  }

  height: ${({ heightString }) => heightString};
  transition: height 0.3s;

  .body {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export default GroupFlexContainer;